import { REMOVER_FILTRO_ENCOMENDA } from '../types'

export default function removerFiltroEncomenda (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_ENCOMENDA
  }
}
